var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.87rem",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-simple-solid",
    d: "M10.714,35.214A3.215,3.215,0,0,1,13.929,32h2.143a3.215,3.215,0,0,1,3.214,3.214V58.786A3.215,3.215,0,0,1,16.071,62H13.929a3.215,3.215,0,0,1-3.214-3.214ZM0,48.071a3.215,3.215,0,0,1,3.214-3.214H5.357a3.215,3.215,0,0,1,3.214,3.214V58.786A3.215,3.215,0,0,1,5.357,62H3.214A3.215,3.215,0,0,1,0,58.786ZM24.643,36.286h2.143A3.215,3.215,0,0,1,30,39.5V58.786A3.215,3.215,0,0,1,26.786,62H24.643a3.215,3.215,0,0,1-3.214-3.214V39.5A3.215,3.215,0,0,1,24.643,36.286Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon);
export default __webpack_public_path__ + "static/media/statistics-icon.a55f8a1e7ecb5cb8a8aecca002ea63e0.svg";
export { ForwardRef as ReactComponent };